import { useState } from "react";
import axios from "axios";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaEnvelope,
  FaSpinner,
  FaWhatsapp,
  FaLinkedinIn
} from "react-icons/fa";




import img from "../assests/images/South-Travels-Footer-Logo.png";
import { NavLink, Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubscribe = async () => {
    setSuccessMessage("");
    setErrorMessage("");

    if (!email) {
      setErrorMessage("Please enter your email address.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://hotel.southtravels.com/api/subscribe",
        { email }
      );

      setSuccessMessage(response.data.message);
      setEmail("");
    } catch (error) {
      if (error.response?.data?.errors?.email) {
        setErrorMessage(error.response.data.errors.email[0]);
      } else {
        setErrorMessage(
          error.response?.data?.message || "Something went wrong."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300 pt-12 sm:pt-16 pb-8">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* Brand Section */}
        <div>
          <NavLink to="/" onClick={() => window.scrollTo(0, 0)}>
            <img
              src={img}
              alt="Logo"
              className="h-[40px] sm:h-[50px] xl:h-[70px] w-auto mb-4"
            />
          </NavLink>

          <p className="text-gray-400 text-sm leading-relaxed">
            We provide premium travel experiences in Dubai and beyond.
            Explore amazing tours with comfort, safety, and unforgettable memories.
          </p>

          <div className="flex gap-3 mt-6">

            {/* Facebook */}
            <a
              href="https://www.facebook.com/SouthTravelsUAE/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition"
            >
              <FaFacebookF className="w-4 h-4 text-white" />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/southtravels8376/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 transition"
            >
              <FaInstagram className="w-4 h-4 text-white" />
            </a>

            {/* WhatsApp */}
            <a
              href="https://api.whatsapp.com/send?phone=971502477593&text=Hi, I would like to inquire about something. I found your website at https://www.southtravels.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-green-500 transition"
            >
              <FaWhatsapp className="w-4 h-4 text-white" />
            </a>

            {/* Twitter / X */}
            <a
              href="https://twitter.com/SouthTravels"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-sky-500 transition"
            >
              <FaTwitter className="w-4 h-4 text-white" />
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/south-travels-dmcc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-700 transition"
            >
              <FaLinkedinIn className="w-4 h-4 text-white" />
            </a>

          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">
            Quick Links
          </h3>

          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/" onClick={() => window.scrollTo(0, 0)} className="hover:text-teal-400 transition">
                Home
              </Link>
            </li>

            <li>
              <Link to="/about-us" className="hover:text-teal-400 transition">
                About Us
              </Link>
            </li>

            <li>
              <Link to="/destinations" className="hover:text-teal-400 transition">
                Tours
              </Link>
            </li>

            <li>
              <Link to="/contact-us" className="hover:text-teal-400 transition">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Support */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">
            Support
          </h3>

          <ul className="space-y-3 text-sm">
            <li><a href="/faqs" className="hover:text-teal-400">FAQ</a></li>
            <li><a href="/privacy-policy" className="hover:text-teal-400">Privacy Policy</a></li>
            <li><a href="/terms-conditions" className="hover:text-teal-400">Terms & Conditions</a></li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">
            Newsletter
          </h3>

          <p className="text-sm text-gray-400 mb-4">
            Subscribe to get updates, travel deals, and exclusive offers.
          </p>

          <div className="space-y-3">

            {/* Input */}
            <div className="flex items-center bg-gray-800 border border-gray-700 rounded-xl overflow-hidden focus-within:border-teal-500">
              <span className="px-3 sm:px-4 text-gray-400">
                <FaEnvelope size={14} />
              </span>

              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-transparent w-full px-2 py-3 text-sm text-white outline-none"
              />
            </div>

            {/* Button */}
            <button
              onClick={handleSubscribe}
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 disabled:opacity-60 text-white py-3 rounded-xl text-sm font-semibold transition"
            >
              {loading ? (
                <>
                  <FaSpinner className="animate-spin" />
                  Subscribing...
                </>
              ) : (
                "Subscribe"
              )}
            </button>

            {/* Messages */}
            {successMessage && (
              <div className="bg-green-500/10 border border-green-500/20 text-green-400 text-sm rounded-xl px-4 py-3">
                {successMessage}
              </div>
            )}

            {errorMessage && (
              <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm rounded-xl px-4 py-3">
                {errorMessage}
              </div>
            )}
          </div>
        </div>

      </div>

      <a
        href="https://wa.me/+971502477593?text=Hello%20SouthTravels,%20I%20would%20like%20to%20check%20hotel%20availability,%20pricing,%20and%20current%20offers."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-[9999] group"
      >
        {/* Pulse Ring */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></span>

        {/* Notification Badge */}
        <div className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full animate-pulse"></div>

        {/* WhatsApp Button */}
        <div className="relative w-16 h-16 rounded-full bg-[#25D366] shadow-2xl flex items-center justify-center hover:scale-110 transition-all duration-300">
          <FaWhatsapp size={36} className="text-white" />
        </div>

        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 -translate-y-1/2 bg-white text-slate-800 px-4 py-2 rounded-lg shadow-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none">
          Need Help? Chat with us
        </div>
      </a>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 mt-10 sm:mt-12 pt-6 text-center text-xs sm:text-sm text-gray-500 px-4">
        © {new Date().getFullYear()} Hotels{" "}

        <a
          href="https://southtravels.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-teal-400 hover:text-teal-300 transition"
        >
          Southtravels
        </a>

        . All rights reserved.
      </div>
    </footer>
  );
}